<template>
  <button
    @click="($event) => $emit('click', $event)"
    class="frisbuy-like-button"
    :class="[{ 'frisbuy-like-button--liked': isLiked }]"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M4 2H14V15L9.3125 10.2979L4 15V2Z" stroke="#000B0B"/>
    </svg>
  </button>
</template>

<style scoped lang="scss">
.frisbuy-like-button {
  position: relative;
  display: block;
  background-color: #ffffff;
  border: none;
  margin-right: 6px;

  min-width: 18px;
  min-height: 18px;

  cursor: pointer;

  z-index: 1;

  &.frisbuy-like-button--liked {
    svg {
      fill: #6e6e6e;
    }
  }

  svg {
    position: absolute;
    top: 0;

    width: 18px;
    height: 18px;

    transform: translateX(-50%);

    fill: #ffffff;
  }
}
</style>

<script>
export default {
  emits: ["click"],

  props: {
    isLiked: {
      type: Boolean,
      required: false,
      default: false,
    },

    productArticle: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
